<template>
  <div class="Component image-wrapper-container" :data-image-size="imageSize" v-if="imageUrl">
    <h3 v-if="imageTitleHtml" v-html="imageTitleHtml"></h3>
    <img :src="imageUrl" :alt="imageAlt" class="news-image" />
  </div>
</template>

<script>
import { renderPrismicContent, getCleanPrismicImageUrl } from '../helpers/prismicHelpers';

export default {
  name: 'ImageWrapper',
  props: {
    sliceData: {
      type: Object,
      required: true
    },
    prismicLang: {
      type: String,
      required: true
    }
  },
  computed: {
    imageUrl() {
      const url = this.sliceData?.primary?.image?.url || '';
      return getCleanPrismicImageUrl(url);
    },
    imageAlt() {
      return this.sliceData?.primary?.image?.alt || 'News Image';
    },
    imageTitleHtml() {
      const titleArray = this.sliceData?.primary?.title;
      if (!titleArray || !Array.isArray(titleArray) || titleArray.length === 0) {
        return '';
      }
      return renderPrismicContent(titleArray);
    },
    imageSize() {
      const size = this.sliceData?.primary?.size || '100%';
      const cleanSize = size.replace('%', '');
      return `width-${cleanSize}`;
    }
  }
};
</script>


